import  UrlPattern  from './url-pattern'

var each = function(arr, fnc) {
  var data = []
  for (var i = 0; i < arr.length; i++) data.push(fnc(arr[i]))
  return data
}

var isArray =
  Array.isArray ||
  function(obj) {
    return Object.prototype.toString.call(obj) == '[object Array]'
  }
export function deparam(params, coerce) {
  var obj = {},
    coerce_types = { true: !0, false: !1, null: null }

  // Iterate over all name=value pairs.
  each(params.replace(/\+/g, ' ').split('&'), function(v, j) {
    var param = v.split('='),
      key = decodeURIComponent(param[0]),
      val,
      cur = obj,
      i = 0,
      // If key is more complex than 'foo', like 'a[]' or 'a[b][c]', split it
      // into its component parts.
      keys = key.split(']['),
      keys_last = keys.length - 1

    // If the first keys part contains [ and the last ends with ], then []
    // are correctly balanced.
    if (/\[/.test(keys[0]) && /\]$/.test(keys[keys_last])) {
      // Remove the trailing ] from the last keys part.
      keys[keys_last] = keys[keys_last].replace(/\]$/, '')

      // Split first keys part into two parts on the [ and add them back onto
      // the beginning of the keys array.
      keys = keys
        .shift()
        .split('[')
        .concat(keys)

      keys_last = keys.length - 1
    } else {
      // Basic 'foo' style key.
      keys_last = 0
    }

    // Are we dealing with a name=value pair, or just a name?
    if (param.length === 2) {
      val = decodeURIComponent(param[1])

      // Coerce values.
      if (coerce) {
        val =
          val && !isNaN(val)
            ? val // number TODO +val to turn to integer
            : val === 'undefined'
            ? undefined // undefined
            : coerce_types[val] !== undefined
            ? coerce_types[val] // true, false, null
            : val // string
      }

      if (keys_last) {
        // Complex key, build deep object structure based on a few rules:
        // * The 'cur' pointer starts at the object top-level.
        // * [] = array push (n is set to array length), [n] = array if n is
        //   numeric, otherwise object.
        // * If at the last keys part, set the value.
        // * For each keys part, if the current level is undefined create an
        //   object or array based on the type of the next keys part.
        // * Move the 'cur' pointer to the next level.
        // * Rinse & repeat.
        for (; i <= keys_last; i++) {
          key = keys[i] === '' ? cur.length : keys[i]
          cur = cur[key] =
            i < keys_last
              ? cur[key] || (keys[i + 1] && isNaN(keys[i + 1]) ? {} : [])
              : val
        }
      } else {
        // Simple key, even simpler rules, since only scalars and shallow
        // arrays are allowed.

        if (isArray(obj[key])) {
          // val is already an array, so push on the next value.
          obj[key].push(val)
        } else if (obj[key] !== undefined) {
          // val isn't an array, but since a second value has been specified,
          // convert val into an array.
          obj[key] = [obj[key], val]
        } else {
          // val is a scalar.
          obj[key] = val
        }
      }
    } else if (key) {
      // No value was defined, so set something meaningful.
      obj[key] = coerce ? undefined : ''
    }
  })

  return obj
}

export function parseQueryString(url) {
  const a = document.createElement('a')
  a.href = url
  const str = a.search.replace(/\?/, '')
  return deparam(str, true /* coerce values, eg. 'false' into false */)
}

export function parseLoyagramCampaignIdsFromScripts(matchString) {
  var foundEls = []

  var els = document.getElementsByTagName('script')
  var re = /.*widget\.loyagram\.([^/]+\.)?js/

  var campaignSettings = []
  console.log(els)
  for (var i = 0; i < els.length; i++) {
    var el = els[i]

    if (el.src.indexOf(matchString) > -1 && foundEls.indexOf(el) < 0) {
      console.log(el)
      foundEls.push(el)
      var parameters = parseQueryString(el.src)
      console.log(parameters)
      if (parameters.campaign_id) {
        if (parameters.color_primary) {
          parameters.color_primary = '#' + parameters.color_primary
        }
        if (parameters.button_color) {
          parameters.button_color = '#' + parameters.button_color
        }
        if (parameters.widget_color) {
          parameters.widget_color = '#' + parameters.widget_color
        }

        campaignSettings.push(parameters)
      }
    }
    // And in the script tags loop
  }
  return campaignSettings
}


if (typeof String.prototype.capitalize !== 'function') {
  String.prototype.capitalize = function(lc, all) {
    if (all) {
      return this.split(' ')
        .map(function(currentValue, index, array) {
          return currentValue.capitalize(lc)
        }, this)
        .join(' ')
        .split('-')
        .map(function(currentValue, index, array) {
          return currentValue.capitalize(false)
        }, this)
        .join('-')
    } else {
      return lc
        ? this.charAt(0).toUpperCase() + this.slice(1).toLowerCase()
        : this.charAt(0).toUpperCase() + this.slice(1)
    }
  }
}

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(searchString, position) {
    position = position || 0;
    return this.indexOf(searchString, position) === position;
  };
}

export function pageMatch(currentPath, paths){
  for(var i=0; i< paths.length; i++){
    var pattern = new UrlPattern(paths[i])
    if(pattern.match(currentPath)){
      return true
    }
  }
  return false
}

export function isEnabledOnPage(currentPath, config){
  if(config.selection === 'NOWHERE'){
    return false
  }
  if(config.selection === 'SPECIFIC_PAGES'){
    if(pageMatch(currentPath, config.urls)){
      return true
    }
    return false
  }
  if(config.selection === 'ALL_PAGES_EXCEPT'){
    if(pageMatch(currentPath, config.urls)){
      return false
    }
    return true
  }
}

// courtesy https://stackoverflow.com/questions/11381673/detecting-a-mobile-browser
export function mobileCheck () {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

//https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
export function hexToRgb(hex) {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function(m, r, g, b) {
    return r + r + g + g + b + b;
  });

  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? [parseInt(result[1], 16),
      parseInt(result[2], 16),
      parseInt(result[3], 16)
  ] : null;
}


export function rgbToHex(r, g, b) {
  return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}


export function parseAttributesFromQueryString(options){
  var attrs = Object.keys(options).map(function(o){
    if(o.startsWith('attr_')){
      return { [o.slice(5, o.length)]: options[o] }
    }
    else{
      return null
    }
  })

  return attrs.filter((a) => a !== null)
}